import { gql } from '@apollo/client';

export const GET_HIERARCHY = gql`
  query GetHierarchy($id: ID!) {
    hierarchy: getHierarchy(id: $id) {
      id
      name
      description
      levels {
        id
        value
        typeOfSite
        hasSubtypes
        subtypes
      }
    }
  }
`;
